import useVideoRecording from './useVideoRecording';

export default useVideoRecording;
